import React from 'react';

import styled from 'styled-components';

import ScrollReveal from '@components/common/ScrollReveal';
import { Container } from '@components/parts/Container';

import { TDIs } from '@customTypes/TDI';

type Props = {
  tdis: TDIs;
  backgroundColor?: string;
  color?: string;
};

const Wrapper = styled.div`
  margin-top: 50px;
  margin-bottom: 120px;
  @media (min-width: 768px) {
    margin-top: 80px;
    margin-bottom: 150px;
  }
  display: flex;
  flex-direction: row;
  div {
    h6 {
      font-size: 15px;
      @media (min-width: 992px) {
        font-size: 20px;
      }
      font-weight: 500;
      opacity: 0.8;
    }
    h3 {
      font-weight: 700;
      margin-right: 1.5em;
    }
  }
  div:last-of-type {
    h3 {
      margin-right: 0;
    }
  }
`;

export const Metrics: React.FC<Props> = (props) => {
  const { tdis, backgroundColor, color } = props;
  return (
    <Container style={{ backgroundColor, color }}>
      <Wrapper>
        {tdis.map(({ title, description }, index) => (
          <ScrollReveal key={title} intervalDelay={index * 300}>
            <h6>{title}</h6>
            <h3>{description}</h3>
          </ScrollReveal>
        ))}
      </Wrapper>
    </Container>
  );
};
